import { Card, CardContent } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { Route, Routes } from 'react-router-dom'
import TabelPerencanaan from 'examples/Tables/TabelPerencanaan'
import userStore from 'store/userStore'
import { CustomDescrypt } from 'global/func'
import { decodeToken } from 'react-jwt'
import { useEffect, useState } from 'react'
import ArgonButton from 'components/ArgonButton'
import { getDataWithResponse } from 'global/getFunc'
import { Sync } from '@mui/icons-material'
import Swal from 'sweetalert2'
import { postDelete } from 'global/postFunc'
import RincianBelanja from './RincianBelanja'
import DetailProgram from './DetailProgram'
import DetailKegiatan from './DetailKegiatan'
import TambahProgram from './FormPerencanaan/TambahProgram'
import TambahKegiatan from './FormPerencanaan/TambahKegiatan'
import TambahSubKegiatan from './FormPerencanaan/TambahSubKegiatan'
import EditProgram from './FormPerencanaan/EditProgram'

const Perencanaan = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="rincian-belanja" element={<RincianBelanja />} />
            <Route path="detail-program" element={<DetailProgram />} />
            <Route path="detail-kegiatan" element={<DetailKegiatan />} />
        </Routes>
    )
}

const Data = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)
    
    const [data, setData] = useState([])
    const [updating, setUpdating] = useState(false)
    const [loading, setLoading] = useState(false)
    // const [deleting, setDeleting] = useState(false)

    const [parentData, setParentData] = useState({})
    const [openAddChild, setOpenAddChild] = useState(false);
    const handleOpenAddChild = () => setOpenAddChild(true);
    const handleCloseAddChild = () => setOpenAddChild(false);

    const [openEdit, setOpenEdit] = useState(false)
    const [editData, setEditData] = useState({})
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    const [opd, setOpd] = useState({})

    useEffect(() => {
        console.log(editData);
    }, [editData])

    const reqPerencanaan = (params) => {
        if (params) {
            setLoading(true)
            addReq()
            getDataWithResponse(
                // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                decryptedUser,
                (res) => {
                    setData(res)
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
            );
        }
    }

    useEffect(() => {
        console.log(decodedUser);
        setOpd({
            kd_pd: decodedUser.kd_pd,
            nm_pd: decodedUser.nm_pd
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(opd);
        reqPerencanaan(opd.kd_pd)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opd, updating])

    const deleteData = (id, ket, uraian) => {
        console.log(ket);
        
        Swal.fire({
            title: 'Hapus Data' + ket + '?' ,
            text: id + " " + uraian + " akan dihapus",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/admin-opd/tr-perencanaan/delete',
                    {
                        _method: 'DELETE',
                        id: id,
                        ket: ket
                    },
                    decryptedUser,
                    setLoading,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Perencanaan</ArgonTypography>
                            <ArgonButton
                                variant='outlined'
                                color="info"
                                size="small"
                                startIcon={<Sync />}
                                disabled
                            >
                                Sinkron Data SIPD
                            </ArgonButton>
                        </ArgonBox>
                        <ArgonBox display="flex" mb={2}>
                            <TambahProgram
                                decryptedUser={decryptedUser}
                                opd={opd}
                                updating={updating}
                                setUpdating={setUpdating}
                                addReq={addReq}
                                tahunAnggaran={tahunAnggaran}
                                disabled={opd?.kd_pd === undefined}
                            />
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <TabelPerencanaan
                                data={data}
                                loading={loading}
                                handleOpenAddChild={handleOpenAddChild}
                                setParentData={setParentData}
                                setEditData={setEditData}
                                handleOpenEdit={handleOpenEdit}
                                deleteData={deleteData}
                                opd={opd}
                                baseUrl="/a-pd/perencanaan"
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>

            <TambahKegiatan
                decryptedUser={decryptedUser}
                tahunAnggaran={tahunAnggaran}
                open={openAddChild && parentData.ket === 'PROGRAM'}
                handleCloseDialog={handleCloseAddChild}
                parentData={parentData}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />

            <TambahSubKegiatan
                decryptedUser={decryptedUser}
                tahunAnggaran={tahunAnggaran}
                open={openAddChild && parentData.ket === 'KEGIATAN'}
                handleCloseDialog={handleCloseAddChild}
                parentData={parentData}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />

            <EditProgram
                decryptedUser={decryptedUser}
                editData={editData}
                open={openEdit}
                // open={openEdit && editData.ket === 'PROGRAM'}
                handleCloseDialog={handleCloseEdit}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />
        </ArgonBox>
    )
}

export default Perencanaan